import { useState,useCallback } from "react";
import { Stepper, Step, StepLabel, Box, Grid, Stack, Button, Typography } from "@mui/material"
import Contact from './resources/Contact'
import Education from './resources/Education'
import Experience from './resources/Experience'
import Finalize from './resources/Finalize'
import Skills from './resources/Skills'
import Objective from './resources/Objective'
import StepperCard from '../../components/StepperDND'
import { useNavigate } from "react-router-dom";
import update from 'immutability-helper'

const Action = ({fieldValues, handleOnChange,handleIndexedOnChange, handleAddNew, handleDelete, handleDateField, sections, setSections}) =>{
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const selectedTemplate = localStorage.getItem('template') || 1
    let disabledSection = [0]
    if(selectedTemplate == 2 || selectedTemplate == 3 || selectedTemplate == 4 || selectedTemplate == 7){
        disabledSection = [0, 1]
    }
    const handleClose = () => {
        localStorage.setItem("fieldValues", JSON.stringify(fieldValues))
        navigate('/')
    }

    const moveCard = useCallback((dragIndex, hoverIndex) => {
        setSections((sections) =>
            update(sections, {
              $splice: [
                [dragIndex, 1],
                [hoverIndex, 0, sections[dragIndex]],
              ],
            }),
          )
    }, [])

    const renderSection = useCallback((section, index) => {
          return (
              <StepperCard
                key={section}
                index={index}
                text={section}
                moveCard={moveCard}
                activeStep={activeStep}
                disable={disabledSection.includes(parseInt(index)) ? true : false}
              />
          )
        },
        [],
    )


    return <Box m={3}>
        <Box display={'flex'} gap={10} px={6}>
            {sections.map((section, i) => renderSection(section, i))}
        </Box>
        <Box minHeight={'450px'} m={2}>
            {activeStep == 0 && <Contact fieldValues={fieldValues} handleOnChange={handleOnChange}/>}
            {activeStep == 1 && <Objective fieldValues={fieldValues} handleOnChange={handleOnChange}/>}
            {activeStep == 2 && <Education fieldValues={fieldValues} handleIndexedOnChange={handleIndexedOnChange} handleAddNew={handleAddNew} handleDelete={handleDelete} handleDateField={handleDateField}/>}
            {activeStep == 3 && <Experience fieldValues={fieldValues} handleIndexedOnChange={handleIndexedOnChange} handleAddNew={handleAddNew} handleDelete={handleDelete} handleDateField={handleDateField}/>}
            {activeStep == 4 && <Skills fieldValues={fieldValues} handleIndexedOnChange={handleIndexedOnChange} handleAddNew={handleAddNew} handleDelete={handleDelete}/>}
            {activeStep == 5 && <Finalize fieldValues={fieldValues} handleIndexedOnChange={handleIndexedOnChange} handleAddNew={handleAddNew} handleDelete={handleDelete}/>}
        </Box>
        <Grid container px={5}>
            <Grid item xs={2}>
                <Button variant="contained" disabled={!activeStep ?? false} onClick={()=>setActiveStep(activeStep - 1)}>Prev</Button>
            </Grid>
            <Grid item xs={10} gap={2} sx={{display: 'flex', flexDirection: 'row-reverse'}}> 
                {activeStep == 5 && <Button variant="contained" onClick={()=>handleClose()}>Close</Button>}           
                <Button variant="contained" disabled={activeStep == 5 ?? false} onClick={()=>setActiveStep(activeStep + 1)}>Next</Button>   
            </Grid>
        </Grid>
  </Box>
}

export default Action
